import { casesActions } from "configs";
import { useParams, useDispatch, useCurrentCase } from "duck";
import { useDeleteSuspensionsMutation } from "requests";

export const useDeleteSuspension = () => {
  const { id: caseId } = useParams();
  const [deleteSuspension] = useDeleteSuspensionsMutation({
    ignoreResults: true
  });
  const dispatch = useDispatch();
  const shouldSync = useCurrentCase(medicalCase => medicalCase.shouldSync);

  return (ids: (number | string)[]) => {
    if (shouldSync) {
      const filteredIds = ids.filter(id => !Number.isNaN(id));
      return deleteSuspension({
        variables: { input: { ids: filteredIds as number[] } }
      }).then(() => {
        dispatch(casesActions.deleteSuspensions({ _id: caseId, data: ids }));
      });
    }

    dispatch(casesActions.deleteSuspensions({ _id: caseId, data: ids }));
  };
};
